import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=66d895ee&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=66d895ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d895ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d895ee')) {
      api.createRecord('66d895ee', component.options)
    } else {
      api.reload('66d895ee', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=66d895ee&scoped=true&", function () {
      api.rerender('66d895ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JjtwS3KZjfzi/JS/comp/GuestBox.vue"
export default component.exports